export const generateRandomColor = () => `hsl(${Math.floor(Math.random() * 360)}, 75%, 56%)`

export const getNameInitials = (name) => /(\w)\w+\s(\w)/g.exec(name).slice(1).join('')
